export function formatLengthMarker(length: number, fractionDigits: number = 2): string {
  return `${length.toFixed(fractionDigits)}m`;
}
